import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Button, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import _ from 'lodash';
import InputGroupInfo from 'components/InputGroupInfo';

import dangerSvg from 'images/danger.svg';
import starSvg from 'images/star.svg';

import { withFormik, Field, Form } from 'formik';
import * as yup from 'yup';

import InputFeedback from '../InputFeedback';
const SUBMIT_DELAY = 1000;

const TitleSchema = yup.object().shape({
  title: yup.string().required("Title can't be empty"),
  short_code: yup.string().required("Short code can't be empty"),
});

class CreateDomainModal extends Component {
  handleFormChangeDebounced = _.debounce(
    this.props.checkShortCode,
    SUBMIT_DELAY,
  );

  render() {
    const {
      showModal,
      isSubmitting,
      handleSubmit,
      closeModal,
      isValid,
      touched,
      showPremium,
      plan,
      errors,
    } = this.props;
    return (
      <Fragment>
        <Modal isOpen={showModal} className="std-modal">
          <div className="std-modal__close">
            <div className="close-icon" onClick={closeModal} />
          </div>
          <div className="std-modal__content">
            <div className="h3-title">Create new domain</div>
            <div className="std-modal__descr">
              <Form
                onChange={v =>
                  this.handleFormChangeDebounced(v.target, 'create')
                }>
                <Field
                  name="title"
                  render={({ field }) => (
                    <InputGroupInfo
                      type="text"
                      id="domain-title"
                      className="form-input input-border"
                      label="Domain title"
                      placeholder="Enter title for your domain"
                      {...field}
                    />
                  )}
                />
                <InputFeedback error={touched.title && errors.title} />
                <Field
                  name="short_code"
                  render={({ field }) => (
                    <InputGroupInfo
                      staticDomain
                      type="text"
                      plan={plan}
                      id="domain-title"
                      className="form-input input-border static_domain"
                      label="Domain URL"
                      placeholderChar=" "
                      linkRoutes="/domain"
                      placeholder="2EEfnJZ"
                      showPremium={showPremium}
                      {...field}
                    />
                  )}
                />
                <InputFeedback
                  error={touched.short_code && errors.short_code}
                />
              </Form>
              <div className="mark-itm">
                <div className="mark-itm__icon">
                  <img src={dangerSvg} alt="danger" />
                </div>
                <div className="mark-itm__text grey">
                  Select your URL carefully because you will not have option to
                  change it after domain creation
                </div>
              </div>
            </div>
            <div className="std-modal__btn">
              {!showPremium && (
                <Button
                  color="blue"
                  className="dtn btn-blue full-width"
                  onClick={handleSubmit}
                  disabled={!isValid || isSubmitting}>
                  {' '}
                  Create domain
                </Button>
              )}
              {showPremium && (
                <Button
                  color="green"
                  className="dtn btn-green full-width"
                  onClick={handleSubmit}
                  disabled={!isValid || isSubmitting}>
                  {' '}
                  Create premium domain
                </Button>
              )}
            </div>
            <div className="std-modal__bottom">
              <div className="mark-itm">
                <div className="mark-itm__icon" />
                <div className="mark-itm__text">
                  Your new Domain fee will be added to your current billing
                  cycle. Show details
                </div>
              </div>
              {/* <div className="mark-itm">
                <div className="mark-itm__icon">
                  <img src={starSvg} alt="danger" />
                </div>
                <div className="mark-itm__text">
                  This is Premium domain URL.{' '}
                  <strong>You will be charged $5.71 now</strong>, which is
                  prorated for the current billing period.
                </div>
              </div>
              <div className="mark-itm">
                <div className="mark-itm__icon" />
                <div className="mark-itm__text">
                  Starting on March 17, 2019 and until you
                  <Link to="/domain">
                    <span>&nbsp;cancel</span>
                  </Link>
                  , we’ll bill you once a month and your{' '}
                  <strong>new monthly total will be $19.99.</strong>
                  </div>
              </div> */}
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default withFormik({
  mapPropsToValues: () => ({
    title: '',
    short_code: '',
  }),
  isInitialValid: false,
  validationSchema: TitleSchema,
  handleSubmit: async (
    values,
    { props, setSubmitting, setErrors, resetForm },
  ) => {
    await props.handleSubmit(values, setSubmitting, setErrors, resetForm);
  },
})(CreateDomainModal);



// WEBPACK FOOTER //
// ./src/components/CreateDomainModal/CreateDomainModal.js